import { mapState } from 'vuex'
import objectLength from '@/services/mixins/objectLength'

export default {
	mixins: [
		objectLength
	],
	computed: {
        ...mapState(['user'])
	},
	methods: {
		isAdmin () {
			if (this.objectLength(this.user)) {
				const check = this.user.roles.findIndex(item => item.name === 'ADMIN')
				return check > -1
			}
		}
	}
}
